import classnames from 'classnames';
import PropTypes from 'prop-types';

import classes from './index.module.css';
import icons from 'css/icons.module.css';

export const HeaderIcon = ({ className }) => (
  <span className={classnames(className, icons.alistBasic, classes.icon)} />
);

HeaderIcon.propTypes = {
  className: PropTypes.string.isRequired,
};
